'use client';
/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box, Divider, Flex, Text } from '@chakra-ui/react';
// import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
// import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import config from '@config';

/**
 * Renders Footer Component
 * @param {Obj} footerData
 * @param {Str} region
 * @param {Str} language
 * @returns {ReactElement} Footer
 */

const Footer = ({ region, language, footerData }) => {
  // console.log('footerData', footerData);
  const aboutSection = footerData?.allIsoMainMenus?.[0];
  const usefulSection = footerData?.allIsoMainMenus?.[1];
  const contactSection = footerData?.allIsoMainMenus?.[2];
  const terms = footerData?.allIsoMainMenus?.[3];
  const privacy = footerData?.allIsoMainMenus?.[4];
  const allRights = footerData?.allIsoMainMenus?.[5];

  const workshop = contactSection?.submenuItems?.[0];
  const production = contactSection?.submenuItems?.[1];
  const facebook = contactSection?.submenuItems?.[2];
  const youtube = contactSection?.submenuItems?.[3];
  const instagram = contactSection?.submenuItems?.[4];

  return (
    <Box
      as="footer"
      width="100%"
      // border={"2px solid red"}
      position={'relative'}
      pt={{ base: '16rem', md: '10rem', lg: '15rem' }}
      pb={{ base: '10rem', md: '2rem', '2xl': '5rem', lg: '6rem' }}
      px={{ base: '1rem' }}
      id="footer"
      bgImage={`url(${config.imgPath}/d/46272/1724137134-footer-bg.png)`}
      bgSize="cover"
      bgPosition={{ base: 'top', md: 'center' }}
      mt="-160px"
      // mt={{ lg: '-11%' }}
    >
      <Box mx="auto" maxWidth={{ md: 755, xl: 1170, '2xl': '75%' }}>
        <Box
          display={'flex'}
          justifyContent={{
            // lg: 'flex-start',
            md: 'flex-start',
            lg: 'space-between',
          }}
          flexDirection={{ base: 'column', md: 'row' }}
          color={'#FFFFFF'}
          gap={{
            base: '2rem',
            md: '3rem',
            lg: '2rem',
          }}
        >
          {/* Box for about text */}
          <Box
            letterSpacing={'0.32px'}
            maxWidth={'412px'}
            width={{ lg: '100%', md: '37%', lg: '30%' }}
          >
            <Text
              mb={{ lg: '.5rem' }}
              fontWeight={500}
              fontFamily={'var(--FedraSansStd-medium)'}
              fontSize={{ base: '1rem', lg: '20px' }}
              lineHeight={{ base: '25.6px', lg: '2rem' }}
              letterSpacing={'0.32px'}
              textDecoration="none"
            >
              {aboutSection?.title}
            </Text>

            <Text
              fontSize={{ base: '0.875rem', md: '0.875rem', lg: '1rem' }}
              fontWeight={400}
              textAlign={'left'}
              letterSpacing="2%"
              marginTop={{ md: '1rem', lg: '0' }}
              lineHeight={{ base: '22.4px', lg: '25.6px' }}
              fontFamily={'var(--FedraSansStd-book)'}
            >
              {aboutSection?.body.value.document.children
                .map(child => child.children.map(span => span.value).join(''))
                .join('\n')}
            </Text>
          </Box>

          {/* Box for useful links content */}
          <Box letterSpacing={'0.32px'}>
            <Text
              fontWeight={500}
              fontFamily={'var(--FedraSansStd-medium)'}
              mb={{ base: '1rem' }}
              fontSize={{ base: '1rem', lg: '20px' }}
              lineHeight={{ base: '25.6px' }}
              letterSpacing={'0.32px'}
            >
              {usefulSection?.title}
            </Text>

            <Box
              fontSize={{ base: '0.875rem', lg: '1rem' }}
              as="div"
              color={{ base: '#FEFAF6', lg: '#FFFFFF' }}
              fontWeight={400}
              display={'flex'}
              flexDirection={{ base: 'column' }}
              gap={{ base: '1rem' }}
              lineHeight={{ base: '22.4px' }}
              fontFamily={'var(--FedraSansStd-book)'}
            >
              {usefulSection?.submenuItems?.map(item => {
                return (
                  <>
                    <Link
                      href={refineUrlDomain(item?.url, region, language)}
                      _hover={{ color: '#80BDFF' }}
                      prefetch
                    >
                      {item?.title}
                    </Link>
                  </>
                );
              })}
            </Box>
          </Box>

          {/* Box for contact us content */}
          <Box
            letterSpacing={'0.32px'}
            display={'flex'}
            flexDirection={'column'}
            mr={{ xl: '7rem', '2xl': '0' }}
            gap={{ lg: '2rem', base: '1rem', md: '.5rem' }}
          >
            {/* contact us data use here */}
            <Text
              alignSelf={{ lg: 'flex-start' }}
              fontWeight={500}
              color="#FFFFFF"
              fontFamily={'var(--FedraSansStd-medium)'}
              fontSize={{ base: '1rem', lg: '20px' }}
              lineHeight={{ base: '25.6px' }}
              letterSpacing={'0.32px'}
            >
              {contactSection?.title}
            </Text>
            {/* end here  */}
            {/* Box1 */}
            <Box fontSize={{ md: '1rem' }}>
              <Text
                fontFamily={'var(--FedraSansStd-book)'}
                fontSize={{ base: '0.875rem', md: '1rem' }}
              >
                {workshop?.title}:
              </Text>

              {/* for email use here */}
              <Link
                href={`mailto:${workshop?.body?.value.document.children[0].children[0].children[0].value}`}
                fontWeight={500}
                fontFamily={'var(--FedraSansStd-medium)'}
                fontSize={{ base: '0.875rem', lg: '1rem' }}
                lineHeight={{ base: '25.6px' }}
                letterSpacing={'0.32px'}
                _hover={{ color: '#80BDFF' }}
              >
                {
                  workshop?.body?.value.document.children[0].children[0]
                    .children[0].value
                }
              </Link>
            </Box>
            {/* Box 2 */}
            <Box>
              <Text
                fontFamily={'var(--FedraSansStd-book)'}
                fontSize={{ base: '0.875rem', md: '1rem' }}
              >
                {production?.title}
              </Text>
              <Link
                fontWeight={500}
                href={`mailto:${production?.body?.value.document.children[0].children[0].children[0].value}`}
                fontFamily={'var(--FedraSansStd-medium)'}
                fontSize={{ base: '0.875rem', lg: '1rem' }}
                lineHeight={{ base: '25.6px' }}
                letterSpacing={'0.32px'}
                _hover={{ color: '#80BDFF' }}
              >
                {
                  production?.body?.value.document.children[0].children[0]
                    .children[0].value
                }
              </Link>
            </Box>
            {/* Icons will come later here */}
            <Box
              display={'flex'}
              gap={{ base: '1.8rem', md: '1.5rem' }}
              fontSize={{ base: '1.5rem', md: '2rem', '2xl': '3rem' }}
              justifyContent={{ base: 'center' }}
              alignItems="center"
              alignSelf={{ lg: 'flex-start' }}
            >
              {/* facebook icon */}
              <Link
                href={facebook?.url}
                _hover={{ color: '#80BDFF' }}
                order={'3'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LazyLoadImageComponent
                  src={facebook?.icon?.url}
                  alt="Facebook"
                />
              </Link>
              {/* youtube icon */}
              <Link
                href={youtube?.url}
                _hover={{ color: '#80BDFF' }}
                order={'1'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LazyLoadImageComponent
                  src={youtube?.icon?.url}
                  alt="YouTube"
                />
              </Link>
              {/* instagram icon */}
              <Link
                href={instagram?.url}
                _hover={{ color: '#80BDFF' }}
                order={'2'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LazyLoadImageComponent
                  src={instagram?.icon?.url}
                  alt="Instagram"
                  // width={{ '2xl': '21px' }}
                  // height={{ '2xl': '32px' }}
                />
              </Link>
            </Box>
          </Box>
        </Box>

        {/* Box for terms */}
        <Flex alignItems="flex-start" flexDir={{ base: 'column', lg: 'row' }}>
          <Box
            color={'#FFFFFF'}
            fontFamily={'var(--FedraSansStd-book)'}
            display={'flex'}
            w={{ lg: '370px', '2xl': 360 }}
            cursor={'pointer'}
            flexDirection={'column'}
            gap={{ base: '1rem', md: '0', lg: '.5rem', '2xl': '.5rem' }}
            mt={{ base: '2rem' }}
          >
            <Box
              textDecoration={'underline'}
              fontSize={{ base: '0.875rem', lg: '1rem' }}
              display="flex"
              gap={{ lg: '1rem', base: '.5rem' }}
            >
              <Link
                href={refineUrlDomain(terms?.url, region, language)}
                _hover={{ color: '#80BDFF' }}
                prefetch
              >
                {terms?.title}
              </Link>

              {/* | */}
              <Divider
                orientation="vertical"
                height="1.625rem"
                borderColor="#FFFFFF"
              />
              <Link
                href={refineUrlDomain(privacy?.url, region, language)}
                _hover={{ color: '#80BDFF' }}
                prefetch
              >
                {privacy?.title}
              </Link>
            </Box>

            <Text fontSize={{ base: '0.75rem' }} _hover={{ color: '#80BDFF' }}>
              {/* <StructuredTextParser
                fontSize={{ base: '0.75rem' }}
                _hover={{ color: '#80BDFF' }}
                str={render(allRights)}
                region={region}
                lang={lang}
              /> */}
              {allRights?.body?.value?.document?.children[0].children[0].value}
            </Text>
          </Box>
          {/* Kolam */}
          <Box
            display={{ base: 'flex' }}
            ml={{ '2xl': '3rem' }}
            // position={{ base: 'absolute', xl: "static" }}
            left={{ md: '57%', '2xl': '40%', lg: '38%', xl: '33%' }}
            justifyContent={'center'}
            bottom={{
              base: '2rem',
              md: '5%',
              lg: '12%',
              '2xl': '16%',
            }}
            // width={{ base: '90%', md: '40%', lg: '100%' }}
            opacity={{ base: '70%', lg: '100%', '2xl': '70%' }}
            height={{ lg: '100px' }}
            // mx="auto"
            maxW={{
              base: '100%',
              sm: '325px',
              md: '300px',
              xl: '450px',
              '2xl': '646px',
            }}
            mt={{ base: '2.5rem', lg: '0' }}
          >
            <LazyLoadImageComponent
              src={`${config.imgPath}/d/46272/1722877370-kolam-footer-1.png`}
              alt="Footer Kolam"
              maxW="100%"
              objectFit="contain"
            />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default Footer;
